export const isTop = name => ['today', 'recommend', 'mine'].indexOf(name) !== -1

let component

export function setComponent (com) {
  component = com
}

export function getComponent () {
  return component
}

export function getBarEnable () {
  return component.enable
}
